import React from 'react';

export const FORCE_CLOSE_EVENT = 'force_close_select';

/**
 * It listens for the `FORCE_CLOSE_EVENT` event and triggers a callback attached to it;
 * Useful if you want to close Select component from another part of an application
 * @param cb
 */
export function useForceCloseEvent(cb: (open: boolean) => void) {
  React.useEffect(() => {
    const onLoadingEvent = (event: Event) => {
      if (event.type === FORCE_CLOSE_EVENT) {
        cb(false);
      }
    };

    document.addEventListener(FORCE_CLOSE_EVENT, onLoadingEvent);

    // cleanup this component
    return () => {
      document.removeEventListener(FORCE_CLOSE_EVENT, onLoadingEvent);
    };
  }, [cb]);
}
